import checkIfMobile from "./checkIfMobile";
import debounce from "./debounce-promise";
import gTag from "./gTag";
import getAccountSymbolSrc from "./getAccountSymbolSrc";
import getAlphanumericValueFromString from "./getAlphanumericValueFromString";
import getAttributesFromAddress from "./getAttributesFromAddress";
import getCountryNameFromCode from "./getCountryNameFromCode";
import getFlagFromCountry from "./getFlagFromCountry";
import getLinesFromAddress from "./getLinesFromAddress";
import getNameFromAccount from "./getNameFromAccount";
import getNameFromSession from "./getNameFromSession";
import getNonSanctionedCountries from "./getNonSanctionedCountries";
import getParsedJSON from "./getParsedJSON";
import getRecipientsFromString from "./getRecipientsFromString";
import { getTeamRoleDescription, getTeamRoleLabel } from "./getTeamRoleStrings";
import openPopupFromInvoice from "./openPopupFromInvoice";
import { atDateToMoment, onDateToMoment } from "./parseDate";
import referencePersonToAttributes from "./referencePersonToAttributes";
import {
  GetRoutePathProps,
  Module,
  RoutesByModule,
  checkIsRoutePath,
  getDefaultRouteNameFromModule,
  getLocalePrefix,
  getPath,
  getRoutePath,
  unspecifiedSlugString,
  unspecifiedTypeString,
  useDefaultRoutePath,
  useRoutePaths,
} from "./router";
import storage from "./storage";
import { fonts, getColorsFromPrimary } from "./theme";
import {
  bankAccountNumberValidationSchema,
  confirmationCodeSchema,
  emailValidationSchema,
  invoiceStartingNumberSchema,
  passwordValidationSchema,
  phoneValidationSchema,
} from "./validators";

export {
  checkIfMobile,
  debounce,
  gTag,
  getAttributesFromAddress,
  getCountryNameFromCode,
  getFlagFromCountry,
  getLinesFromAddress,
  getNonSanctionedCountries,
  getParsedJSON,
  getTeamRoleDescription,
  getTeamRoleLabel,
  openPopupFromInvoice,
  atDateToMoment,
  onDateToMoment,
  referencePersonToAttributes,
  confirmationCodeSchema,
  emailValidationSchema,
  passwordValidationSchema,
  phoneValidationSchema,
  invoiceStartingNumberSchema,
  getRecipientsFromString,
  storage,
  getColorsFromPrimary,
  fonts,
  bankAccountNumberValidationSchema,
  getAlphanumericValueFromString,
  getAccountSymbolSrc,
  getNameFromAccount,
  getNameFromSession,
  getPath,
  getRoutePath,
  unspecifiedTypeString,
  unspecifiedSlugString,
  useRoutePaths,
  getLocalePrefix,
  useDefaultRoutePath,
  getDefaultRouteNameFromModule,
  checkIsRoutePath,
};

export type { RoutesByModule, Module, GetRoutePathProps };
